import { render, staticRenderFns } from "./verify-modal.vue?vue&type=template&id=3dd30c7a&scoped=true&"
import script from "./verify-modal.vue?vue&type=script&lang=jsx&"
export * from "./verify-modal.vue?vue&type=script&lang=jsx&"
import style0 from "./verify-modal.vue?vue&type=style&index=0&id=3dd30c7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd30c7a",
  null
  
)

export default component.exports